export default "__VITE_ASSET__ki$ycGJD__"